'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _panZoom = require('./components/pan-zoom');

Object.defineProperty(exports, 'PanZoom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_panZoom).default;
  }
});

var _pinchHandler = require('./components/pinch-handler');

Object.defineProperty(exports, 'PinchHandler', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pinchHandler).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-pan-zoom/lib/index.js
// module id = 1338
// module chunks = 1